<template>
  <section
    ref="root"
    class="flex flex-col gap-2"
  >
    <label class="text-base font-semibold text-gray-800">{{ label }}{{ required ? ' *' : '' }}</label>
    <slot />
  </section>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  label: { type: String, default: '' },
  required: { type: Boolean },
});

const root = ref(null);

defineExpose({ root });
</script>
